// hp-challenge.js — stacked card scroll animation (responsive)

export function initHpChallenge() {
  const wrap = document.querySelector('.section-sticky_wrap');
  const section = document.querySelector('.section-sticky_wrap');
  const card1 = document.querySelector('.hp-challenge_card.is--1');
  const card2 = document.querySelector('.hp-challenge_card.is--2');
  const card3 = document.querySelector('.hp-challenge_card.is--3');

  if (!wrap || !section || !card1 || !card2 || !card3) return;

  const DURATION = 0.4;
  const OPACITY_DURATION = 0.15;
  const EASE = 'power3.out';
  const PEEK_1 = -10;
  const PEEK_2 = -20;
  const ENTRY_Y = 150;

  const COLORS = [
    ['#F0F3FF', '#E9EBFF', '#E1E3FF'], // state 0: card1 on top
    ['#D3D8FD', '#E1E3FF', '#E9EBFF'], // state 1: card2 on top
    ['#D3D8FD', '#E1E3FF', '#F0F3FF'], // state 2: card3 on top
  ];

  // Initial stack (shared across breakpoints)
  gsap.set(card1, { y: 0, opacity: 1, zIndex: 3, backgroundColor: COLORS[0][0] });
  gsap.set(card2, { y: ENTRY_Y, opacity: 0, zIndex: 2, backgroundColor: COLORS[0][1] });
  gsap.set(card3, { y: ENTRY_Y, opacity: 0, zIndex: 1, backgroundColor: COLORS[0][2] });

  let activeState = 0;

  const goToState0 = () => {
    if (activeState === 0) return;
    activeState = 0;
    gsap.to(card1, {
      y: 0,
      zIndex: 3,
      backgroundColor: COLORS[0][0],
      duration: DURATION,
      ease: EASE,
    });
    gsap.to(card2, {
      y: ENTRY_Y,
      zIndex: 2,
      backgroundColor: COLORS[0][1],
      duration: DURATION,
      ease: EASE,
    });
    gsap.to(card2, { opacity: 0, duration: OPACITY_DURATION, ease: EASE });
    gsap.to(card3, {
      y: ENTRY_Y,
      zIndex: 1,
      backgroundColor: COLORS[0][2],
      duration: DURATION,
      ease: EASE,
    });
    gsap.to(card3, { opacity: 0, duration: OPACITY_DURATION, ease: EASE });
  };
  const goToState1 = () => {
    if (activeState === 1) return;
    activeState = 1;
    gsap.to(card1, {
      y: PEEK_1,
      zIndex: 3,
      backgroundColor: COLORS[1][0],
      duration: DURATION,
      ease: EASE,
    });
    gsap.to(card2, {
      y: 0,
      zIndex: 4,
      backgroundColor: COLORS[1][1],
      duration: DURATION,
      ease: EASE,
    });
    gsap.to(card2, { opacity: 1, duration: OPACITY_DURATION, ease: EASE });
    gsap.to(card3, {
      y: ENTRY_Y,
      zIndex: 1,
      backgroundColor: COLORS[1][2],
      duration: DURATION,
      ease: EASE,
    });
    gsap.to(card3, { opacity: 0, duration: OPACITY_DURATION, ease: EASE });
  };
  const goToState2 = () => {
    if (activeState === 2) return;
    activeState = 2;
    gsap.to(card1, {
      y: PEEK_2,
      zIndex: 3,
      backgroundColor: COLORS[2][0],
      duration: DURATION,
      ease: EASE,
    });
    gsap.to(card2, {
      y: PEEK_1,
      zIndex: 4,
      backgroundColor: COLORS[2][1],
      duration: DURATION,
      ease: EASE,
    });
    gsap.to(card3, {
      y: 0,
      zIndex: 5,
      backgroundColor: COLORS[2][2],
      duration: DURATION,
      ease: EASE,
    });
    gsap.to(card3, { opacity: 1, duration: OPACITY_DURATION, ease: EASE });
  };

  const onUpdate = (self) => {
    const p = self.progress;
    if (p < 1 / 3) goToState0();
    else if (p < 2 / 3) goToState1();
    else goToState2();
  };

  const navbar = document.querySelector('.navbar-c_wrapper');
  const getNavHeight = () => (navbar ? navbar.getBoundingClientRect().height : 0);

  const mm = gsap.matchMedia();

  // Desktop: pin the sticky wrap (challenge + acquire share the pin)
  mm.add('(min-width: 992px)', () => {
    const navHeight = getNavHeight();
    const scrollPerStep = window.innerHeight * 0.5;

    ScrollTrigger.create({
      trigger: wrap,
      start: `top ${navHeight}px`,
      end: `+=${scrollPerStep * 3}`,
      pin: true,
      pinSpacing: true,
      onUpdate,
    });
  });

  // Mobile: pin only the challenge section
  mm.add('(max-width: 991px)', () => {
    const navHeight = getNavHeight();
    const scrollPerStep = window.innerHeight * 0.5;

    ScrollTrigger.create({
      trigger: section,
      start: 'bottom bottom',
      end: `+=${scrollPerStep * 3}`,
      pin: true,
      pinSpacing: true,
      onUpdate,
    });
  });
}
